export const orderFieldMap = {
	closed: 'Status',
	documentStatus: 'Tipo',
	moment: 'Data',
	companyName: "Azienda",
	group: "Gruppo",
	operatorUsername: "Agente",
	numDocOriginale: "Documento",
	customer: "Cliente",
	itemsMagnitude: "Articoli",
	device: "Device",
	appVersion: "Version",
	// applicablePromotion: "Promozione",
	// id: "id",
	// _id: "dbID",
	// operatorId: "opID",
	// operatorSyncUrl: "syncURL",
	// deliveryDate: "Consegna",
};

export const OrderStatus = {
	DRAFT: { id: 0, label: "Bozza", shortLabel: "BOZ", colorKey: "draft" },
	ORDER: { id: 1, label: "Ordine", shortLabel: "ORD", colorKey: "order" },
	QUOTE: { id: 21, label: "Preventivo", shortLabel: "PRV", colorKey: "quote" },
};

export function getOrderStatusMeta(orderStatus?: number): { label: string, shortLabel: string, colorKey: string } | null {
	if (orderStatus === undefined || orderStatus === null) return null;
	return Object.values(OrderStatus).find(({ id }) => id === orderStatus) || null;
}

export const articleFieldMap = {
	codice: "Codice",
	name: "Articolo",
	// "DesEstesa": "Descrizione",
	"prezzo": "Prezzo",
	"startPrice": "Prezzo di partenza",
	"qt": "Qt",
	// "listino": "Listino"
};

export const ExternalPromoAlerts = {
	Headers: {
		PaymentDiscount: {
			id: 2,
			label: 'sconto pagamento'
		}
	},
	Payloads: {
		PriceEdit: {
			id: 1,
			label: 'prezzo'
		},
		UnitaryDiscount: {
			id: 3,
			label: 'sconto unitario'
		},
		PercentageDiscount: {
			id: 4,
			label: 'sconto percentuale'
		},
		QuantityDiscount: {
			id: 5,
			label: 'sconto quantità'
		}
	}
}

export const ExternalPromoRowType = {
	Articolo: {
		id: 1,
		label: 'Articolo'
	},
	ScontoMerce: {
		id: 2,
		label: 'Sconto merce'
	},
	Omaggio: {
		id: 3,
		label: 'Omaggio'
	},
	ExtraCanvass: {
		id: 4,
		label: 'Extra Canvass'
	},
}
